export const isNullish = <T>(x: T | undefined | null): x is undefined | null => (
	x === null || x === undefined
);

export const notNullish = <T>(x: T | undefined | null): x is T => (
	x !== null && x !== undefined
);
